<template>
  <div class="watermark-wrapper">
    <img :src="watermarkImage" alt="Watermark" class="watermark-image" />
  </div>
</template>

<script>
export default {
  name: "Watermark",
  data() {
    return {
      watermarkImage: this.$brand.logo,
    };
  },
};
</script>

<style scoped lang="scss">
.watermark-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.watermark-image {
  opacity: 0.2;
  max-width: 400px;
  max-height: 400px;
  width: auto;
  height: auto;
  object-fit: contain;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media print {
  .watermark-wrapper {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 0 !important;
    page-break-inside: avoid;
    page-break-after: avoid;
    page-break-before: avoid;
  }

  .watermark-image {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    opacity: 0.2 !important;
    z-index: 0 !important;
  }

  @page {
    @top-center {
      content: "";
    }
  }
}

/* For vue-html2pdf PDF generation */
::v-deep .watermark-wrapper {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 0 !important;
}
</style>
